import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import FieldHelp from '../../../shared/FieldHelp';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function ProductTypeForm({ initial, onSave, onCancel, loading }) {
  const [code, setCode] = useState(initial?.code || '');
  const [name, setName] = useState(initial?.name || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [canBuy, setCanBuy] = useState(initial?.can_buy ?? true);
  const [canSell, setCanSell] = useState(initial?.can_sell ?? true);
  const [canTrack, setCanTrack] = useState(initial?.can_track ?? true);
  const [error, setError] = useState('');

  const locked = !!initial?.is_system_default;

  const validate = () => {
    if (!code.trim()) return 'Code is required.';
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      code: code.trim().toUpperCase(),
      name: name.trim(),
      description: description.trim(),
      can_buy: canBuy,
      can_sell: canSell,
      can_track: canTrack,
    });
  };

  return (
    <form className="product-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
            placeholder="e.g., P"
            disabled={locked}
            style={{ width: 100 }}
          />
        </div>
        <div>
          <label>Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Purchased"
            disabled={locked}
          />
        </div>
      </div>

      {locked && (
        <div style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
          This is a locked Product Type — its code and name can't be changed.
        </div>
      )}

      <div style={{ marginTop: 14 }}>
        <label>Description</label><br />
        <textarea
          className="styled-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          style={{ width: '100%', maxWidth: 480, resize: 'vertical' }}
          placeholder="Optional notes on how this Product Type is used"
        />
      </div>

      <div style={{ marginTop: 14, display: 'flex', gap: 16, alignItems: 'center' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
          <label><input type="checkbox" checked={canBuy} onChange={(e) => setCanBuy(e.target.checked)} /> Can Buy</label>
          <FieldHelp fieldKey="inventory-product-types.can-buy" pageKey="inventory-product-types" articleSlug="inventory-controls" articleTitle="Inventory Controls" label="Can Buy">Controls whether this Product/UoM appears on a Purchase Order.</FieldHelp>
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
          <label><input type="checkbox" checked={canSell} onChange={(e) => setCanSell(e.target.checked)} /> Can Sell</label>
          <FieldHelp fieldKey="inventory-product-types.can-sell" pageKey="inventory-product-types" articleSlug="inventory-controls" articleTitle="Inventory Controls" label="Can Sell">Controls whether this Product/UoM appears on a Pricelist, Quote, or Sales Order.</FieldHelp>
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
          <label><input type="checkbox" checked={canTrack} onChange={(e) => setCanTrack(e.target.checked)} /> Can Track</label>
          <FieldHelp fieldKey="inventory-product-types.can-track" pageKey="inventory-product-types" articleSlug="inventory-controls" articleTitle="Inventory Controls" label="Can Track">Controls whether on-hand quantity can be held directly for this Product/UoM.</FieldHelp>
        </span>
      </div>
      <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
        A Product UoM of this Product Type can't have a flag on that this Product Type has off.
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default ProductTypeForm;
